<template>
  <div>
    <!-- <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleBatchCancelOrder()" v-show="isShow('second')">批量取消
    </el-button>
    <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleBatchCancelOrder()" v-show="isShow('third')">批量取消
    </el-button>
    <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleBatchReviewOper()" v-show="isShow('fourth')">批量审核
    </el-button>
    <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleOpt()" v-show="isShow('five')" disabled>批量语音催单
    </el-button>
    <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleBatchMoneyOper('审核金额')" v-show="isShow('six')">审核金额
    </el-button>
    <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleconfirmSend()" v-show="isShow('six')">批量确认发货
    </el-button> -->
    <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleBatchReviewOper()" v-show="isShow('seven')">批量审核
    </el-button>
    <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleBatchReviewOper()" v-show="isShow('nine')">批量审核
    </el-button>
    <!-- <el-button type="success" size="small" style="margin: 10px 20px 0 0"
               @click="handleFinshconfirmSend()" v-show="isShow('ten')">批量确认
    </el-button> -->
    <el-table :data="tableData"
              ref="table"
              border default-expand-all
              :max-height="tableHeight"
              style="width: 100%;margin-top: 20px"
              :key="currentMenu"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column
          v-for="(it, index) in tableFeildAndVal" :key="index"
          :label="it.lable"
          :prop="it.key"
          :sortable="it.sortable"
          min-width="15%" align="center">
        <template slot-scope="scope">
        <span v-if="scope.column.property == 'taskNum'">
          <router-link :to="{path: '/home/businesstaskdetails', query: {b2cTaskId: scope.row[scope.column.property]}}" >
            <span style="color: #04befe">{{ scope.row[scope.column.property] }}</span></router-link>
        </span>
          <span v-else-if="scope.column.property == 'orderNum'">
            <router-link :to="{path: '/home/taskorderdetail', query: {taskNumbers: scope.row[scope.column.property]}}">
              <span style="color: #04befe">{{ scope.row[scope.column.property] }}</span>
            </router-link>
        </span>
          <span v-else-if="scope.column.property == 'flagColor'">
            <span >
              <el-image
                  style="width: 24px; height: 24px"
                  :src="getFlag(scope.row[scope.column.property])"></el-image>
            </span>
          </span>
          <span v-else v-html="scope.row[scope.column.property]">
        </span>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" prop="orderStatus" width="200" align="center"
                       v-if="isOption('first, second, third, five, nine, twelve, twelveone, twelvetwo', 'twelvethree')">
        <template slot-scope="scope">
          <div>{{ scope.row.orderStatus }}</div>
          <!-- <el-button size="mini" type="text"
                     @click="handleAppeal(scope.$index, scope.row,'发起申诉')">
            发起申诉
          </el-button> -->
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="orderStatus" width="200" align="center" v-if="isOption('seven, nine')">
        <template slot-scope="scope">
          <el-button size="mini" type="primary"
                     @click="handleReviewOper(scope.$index, scope.row,'审核')">
            审核
          </el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" prop="orderStatus" width="200" align="center" v-if="isOption('six')">
        <template slot-scope="scope">
          <div>
            <el-button size="mini" type="primary"
                       @click="handleMoneyOper(scope.$index, scope.row,'审核金额')">
              审核金额
            </el-button>
            <el-button size="mini" type="primary"
                       @click="handleUpMoneyOper(scope.$index, scope.row,'修改金额')">
              修改金额
            </el-button>
          </div>
          <el-button size="mini" type="text"
                     @click="handleAppeal(scope.$index, scope.row,'发起申诉')">
            发起申诉
          </el-button>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="操作" prop="orderStatus" width="200" align="center" v-if="isOption('seven')">
        <template slot-scope="scope">
          <div>
            <el-button size="mini" type="primary"
                       @click="confirmSendShip(scope.$index, scope.row,'确认发货返款')">
              确认发货返款
            </el-button>
          </div> -->
          <!--<div>
            <el-button size="mini" type="text"
                       @click="handleRejectCustomerOrder(scope.$index, scope.row,'驳回订单')">
              驳回订单
            </el-button>
          </div>-->
          <!-- <el-button size="mini" type="text"
                     @click="handleAppeal(scope.$index, scope.row,'发起申诉')">
            发起申诉
          </el-button>
        </template>
      </el-table-column> -->
      <el-table-column label="订单状态" prop="orderStatus" width="200" align="center" v-if="isOption('eight')">
        <template slot-scope="scope">
          <span>{{ scope.row.orderStatus }}</span>
          <div>
            <el-button size="mini" type="text"
                       @click="handlePrompReviews(scope.$index, scope.row,'发起催评')">
              发起催评
            </el-button>
          </div>
          <div>
            <el-button size="mini" type="text"
                       @click="handleAddReview(scope.$index, scope.row,'添加评价')">
              添加评价
            </el-button>
          </div>
          <div>
          <el-button size="mini" type="text"
                     @click="handleAppeal(scope.$index, scope.row,'发起申诉')">
            发起申诉
          </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" prop="orderStatus" width="200" align="center" v-if="isOption('ten')">
        <template slot-scope="scope">
          <span>{{ scope.row.orderStatus }}</span>
          <div>
          <el-button size="mini" type="text"
                     @click="handleAppeal(scope.$index, scope.row,'发起申诉')">
            发起申诉
          </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" prop="orderStatus" width="200" align="center" v-if="isOption('elevn')">
        <template slot-scope="scope">
          <span>{{ scope.row.orderStatus }}</span>
          <div v-if="!scope.row.alreadyExtraReview">
            <el-button size="mini" type="text"
                       @click="handleExtraReview(scope.$index, scope.row,'添加追评')">
              可追评
            </el-button>
          </div>
          <div>
            <el-button size="mini" type="text"
                       @click="handleAppeal(scope.$index, scope.row,'发起申诉')">
              发起申诉
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 追评 -->
    <el-dialog :title="dialogExtraTitle" :visible.sync="dialogExtraFormVisible" v-loading.fullscreen.lock="fullscreenLoading">
      <el-form ref="dialogExtraForm" :model="dialogExtraForm" label-width="90px" class="extraClass">
        <el-form-item label="好评类型：" >
          <el-radio-group v-model="dialogExtraForm.taskChecked" @change="taskClassChange">
            <el-radio :label="1">指定文字好评任务
            </el-radio>
            <el-radio :label="2">指定图片好评任务
            </el-radio>
            <el-radio :label="3">指定视频好评任务
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="服务费：" >
          <span style="color: red">{{ serviceMoney }}</span>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="评论内容：" >
          <el-input v-model="dialogExtraForm.reviewContent"
                    placeholder="指定评价内容" style="width: 80%;margin: 1% 0;"></el-input>
        </el-form-item>
        <div v-if="dialogExtraForm.taskChecked != 1">
          <div v-if="dialogExtraForm.taskChecked == 3">
            <el-divider></el-divider>
            <el-form-item label="好评视频：" style="margin-top: 10px;">
              <el-row :gutter="0" class="itemCls">
                <el-col :span="24" id="videoTag">
                  <el-form-item label-width="1%" style="margin-bottom: 10px;">
                    <el-upload
                        action="https://api.weiquanai.com/taskservice/file/upload"
                        :headers="myheader"
                        :show-file-list="false"
                        accept="video/mp4"
                        :before-upload="beforeUpload"
                        :on-success="handleReviewVideoSuccess.bind(null, {index: 0, data:dialogExtraForm, videoIndex:0})"
                        :on-remove="handleMediaRemove">
                      <video v-if="isVideoShow(dialogExtraForm, 0)" width="220" height="220" controls>
                        <source :src="getVideoUrl(dialogExtraForm, 0)" type="video/mp4">
                      </video>
                      <i v-else class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <el-divider></el-divider>
          <el-form-item label="好评晒图：" style="margin-top: 10px;">
            <el-row :gutter="5" class="itemCls" style="margin-bottom: 10px;">
              <el-col :span="4">
                <el-form-item label-width="6%">
                  <el-upload
                      action="https://api.weiquanai.com/taskservice/file/upload"
                      :headers="myheader"
                      :show-file-list="false"
                      accept="image/png,image/gif,image/jpg,image/jpeg"
                      :on-success="handleReviewSuccess.bind(null, {index: 0, data:dialogExtraForm, imgIndex:0})"
                      :on-remove="handleMediaRemove">
                    <div v-if="isImageShow(dialogExtraForm, 0)" style="width: 100%;position: relative;">
                      <img  :src="getImageUrl(dialogExtraForm, 0)" class="avatar">
                      <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleMediaRemove(getImageUrl(dialogExtraForm, 0))"></el-button>
                    </div>
                    <i v-else class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label-width="6%">
                  <el-upload
                      action="https://api.weiquanai.com/taskservice/file/upload"
                      :headers="myheader"
                      :show-file-list="false"
                      accept="image/png,image/gif,image/jpg,image/jpeg"
                      :on-success="handleReviewSuccess.bind(null, {index: 1, data:dialogExtraForm, imgIndex:1})"
                      :on-remove="handleMediaRemove">
                    <div v-if="isImageShow(dialogExtraForm, 1)" style="width: 100%;position: relative;">
                      <img  :src="getImageUrl(dialogExtraForm, 1)" class="avatar">
                      <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleMediaRemove(getImageUrl(dialogExtraForm, 1))"></el-button>
                    </div>
                    <i v-else class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label-width="6%">
                  <el-upload
                      action="https://api.weiquanai.com/taskservice/file/upload"
                      :headers="myheader"
                      :show-file-list="false"
                      accept="image/png,image/gif,image/jpg,image/jpeg"
                      :on-success="handleReviewSuccess.bind(null, {index: 2, data:dialogExtraForm, imgIndex:2})"
                      :on-remove="handleMediaRemove">
                    <div v-if="isImageShow(dialogExtraForm, 2)" style="width: 100%;position: relative;">
                      <img  :src="getImageUrl(dialogExtraForm, 2)" class="avatar">
                      <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleMediaRemove(getImageUrl(dialogExtraForm, 2))"></el-button>
                    </div>
                    <i v-else class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label-width="6%">
                  <el-upload
                      action="https://api.weiquanai.com/taskservice/file/upload"
                      :headers="myheader"
                      :show-file-list="false"
                      accept="image/png,image/gif,image/jpg,image/jpeg"
                      :on-success="handleReviewSuccess.bind(null, {index: 3, data:dialogExtraForm, imgIndex:3})"
                      :on-remove="handleMediaRemove">
                    <div v-if="isImageShow(dialogExtraForm, 3)" style="width: 100%;position: relative;">
                      <img  :src="getImageUrl(dialogExtraForm, 3)" class="avatar">
                      <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleMediaRemove(getImageUrl(dialogExtraForm, 3))"></el-button>
                    </div>
                    <i v-else class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label-width="6%">
                  <el-upload
                      action="https://api.weiquanai.com/taskservice/file/upload"
                      :headers="myheader"
                      :show-file-list="false"
                      accept="image/png,image/gif,image/jpg,image/jpeg"
                      :on-success="handleReviewSuccess.bind(null, {index: 4, data:dialogExtraForm, imgIndex:4})"
                      :on-remove="handleMediaRemove">
                    <div v-if="isImageShow(dialogExtraForm, 4)" style="width: 100%;position: relative;">
                      <img  :src="getImageUrl(dialogExtraForm, 4)" class="avatar">
                      <el-button type="danger" size="mini" icon="el-icon-delete" circle style="z-index: 100;position: absolute;top:35%;left: 36%;opacity: 0.8" @click.stop="handleMediaRemove(getImageUrl(dialogExtraForm, 4))"></el-button>
                    </div>
                    <i v-else class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitAddReview()" size="mini" type="primary">添加好评</el-button>
        <el-button @click="handleExtraCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!-- end -->

    <!-- 金额异常订单审核 -->
    <el-dialog :title="dialogMoneyTitle" :visible.sync="dialogMoneyFormVisible">
      <el-form ref="dialogMoneyForm" :model="dialogMoneyForm" label-width="230px">
        <el-form-item label="审核状态">
          <el-select v-model="dialogMoneyForm.reviewMoneyRes" clearable placeholder="请选择">
            <el-option
                v-for="item in orderReviewOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="dialogMoneyForm.remarks" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitOrderReviewDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleOrderReviewCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!--金额异常订单修改金额操作-->
    <el-dialog :title="dialogUpMoneyTitle" :visible.sync="dialogUpMoneyFormVisible">
      <el-form ref="dialogUpMoneyForm" :model="dialogUpMoneyForm" label-width="230px">
        <el-form-item label="修改后金额">
          <el-input v-model="dialogUpMoneyForm.updateMoney" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="dialogUpMoneyForm.remarks" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitUpdateMoneyDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleUpdateMoneyCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <!--商家自主审核-->
    <el-dialog :title="dialogReviewTitle" :visible.sync="dialogReviewFormVisible">
      <el-form ref="dialogReviewForm" :model="dialogReviewForm" label-width="230px">
        <el-form-item label="审核状态">
          <el-select v-model="dialogReviewForm.reviewRes" clearable placeholder="请选择">
            <el-option
                v-for="item in reviewOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitReviewDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleReviewCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="230px">
        <el-form-item label="备注">
          <el-input v-model="dialogForm.remarks" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogAppealTitle" :visible.sync="dialogAppealFormVisible">
      <el-form ref="dialogAppealForm" :model="dialogAppealForm" label-width="230px">
        <el-form-item label="订单编号">
          <el-input type="number" v-model="dialogAppealForm.orderNumbers" readonly style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="申诉类型" prop="appealType">
          <el-select v-model="dialogAppealForm.appealType" clearable placeholder="请选择">
            <el-option
                v-for="item in businessOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申诉说明">
          <el-input type="textarea" v-model="dialogAppealForm.appealBeacuse" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="截图说明">
          <el-row>
            <el-col :span="12">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="dialogAppealForm.appealImageUrls.length >0" :src="dialogAppealForm.appealImageUrls[0]"
                     class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
            <el-col :span="12">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="dialogAppealForm.appealImageUrls.length >1" :src="dialogAppealForm.appealImageUrls[1]"
                     class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
          </el-row>
          <div style="color: red">最多可添加2张图片，单张图片大小在3M以内选择文件</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogAppealForm()" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialogAppeal" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {
  addBatchPrompReview,
  addPrompReview,
  businessBatchSelfReview,
  businessSelfReview,
  cancelOrder, cancelOrders,
  getOrderTaskList,
  updateBatchOrderStatus, updateOrderMoney,
  updateOrderStatus
} from "../../api/b2cbusiness/b2c_orderlist";
import {getJwtToken, getStrEndWithNumbers, getTokenUser, isStrEmpty} from "../../lib/utils";
import {deleteB2cGoods} from "../../api/b2cbusiness/b2c_goods";
import qs from "qs";
import {commitAppealMessageInfo} from "../../api/b2cbusiness/b2c_admin";
import MinxinScroll from "@/components/MinxinScroll";
import {getAllReviewServiceMoney} from "@/api/b2cbusiness/b2c_servicemoney";
import {addTaskDetailContent, addTaskExtraDetailContent} from "@/api/b2cbusiness/b2c_tasklist";

export default {
  name: "TaskOrderComponent",
  mixins: [MixinCUD, MinxinScroll],
  props: ["currentMenu", "queryForm", "pagination"],
  data() {
    return {
      fullscreenLoading: false,
      myheader: {
        JWTHeaderName: ""
      },
      tableData: [
        // {
        //   orderTime: "2021-06-20 15:24:22 ",
        //   taskNum: "893101",
        //   orderNum: "2805253",
        //   userId: "116017",
        //   shopName: "英利来吉安顺专卖店",
        //   orderInfo: "tb68202048 \n" +
        //       "\n" +
        //       "1334218946500594082\n",
        //   priceDetail: "押金：268.00 + 0.00 \n" +
        //       "\n" +
        //       "服务费：11.00 \n",
        //   realyMoney: "268.00 ",
        //   retMoneyStatus: "本金：未返款 \n" +
        //       "\n" +
        //       "佣金：未返款\n",
        //   orderStatus: "确认发货"
        // }
      ],
      tableHeight: 450,
      dialogExtraFormVisible: false,
      dialogExtraTitle: "",
      dialogExtraRefName: "dialogExtraForm",
      dialogExtraForm: {
        taskChecked: 1,
        imageUrls: [],
        videoUrls: [],
        reviewContent: "",
      },
      serviceMoney: 0,
      commissionMoney:0,
      dialogReviewFormVisible: false,
      dialogReviewTitle: "",
      dialogReviewRefName: "dialogReviewForm",
      dialogReviewForm: {},
      multipleSelection: [],
      dialogAppealFormVisible: false,
      dialogAppealTitle: "",
      dialogAppealRefName: "dialogAppealForm",
      dialogAppealForm: {
        appealImageUrls: []
      },
      businessOptions: [
        {
          label: "本佣金已返买手，买手申请退款",
          value: 202202110001,
        },
        {
          label: "本金已返买手，买手申请退款",
          value: 202202110002,
        },
        {
          label: "买手未好评上传错误截图要求商家返佣",
          value: 202202110003,
        },
        {
          label: "买手排错店铺，或者上传错误截图",
          value: 202202110004,
        },
        {
          label: "买手实际花费低于提交的本金",
          value: 202202110005,
        },
        {

          label: "买手拍错链接",
          value: 202202110006,
        },
        {
          label: "其他错误",
          value: 202202110007
        }
      ],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {},
      reviewOptions: [
        {
          label: "审核通过",
          value: true
        },
        {
          label: "审核拒绝",
          value: false
        }
      ],
      orderReviewOptions: [
        {
          label: "审核通过",
          value: true
        },
        // {
        //   label: "驳回订单",
        //   value: false
        // }
      ],
      dialogMoneyFormVisible: false,
      dialogMoneyTitle: "",
      dialogMoneyRefName: "dialogMoneyForm",
      dialogMoneyForm: {},
      dialogUpMoneyFormVisible: false,
      dialogUpMoneyTitle: "",
      dialogUpMoneyRefName: "dialogUpMoneyForm",
      dialogUpMoneyForm: {},
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      tableFeildAndVal: [
        {
          key: "orderTime",
          sortable: true,
          lable: "接单时间"
        },
        {
          key: "taskNum",
          sortable: false,
          lable: "任务编号"
        },
        {
          key: "orderNum",
          sortable: true,
          lable: "订单编号"
        },
        {
          key: "goodUrl",
          sortable: false,
          lable: "商品链接"
        },
        {
          key: "customeName",
          sortable: false,
          lable: "买手账号"
        },
        {
          key: "plateUserName",
          sortable: false,
          lable: "平台账号"
        },
        {
          key: "money",
          sortable: false,
          lable: "费用"
        },
        {
          key: "commissionPrice",
          sortable: false,
          lable: "服务费"
        },
        {
          key: "retMoneyStatus",
          sortable: false,
          lable: "返款状态"
        }
      ]
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  computed: {
    isImageShow() {
      return function (val, index) {
        if (val.imageUrls != undefined && val.imageUrls.length > index) {
          return true;
        }
        return false;
      }
    },
    getImageUrl() {
      return function (val, index) {
        console.log(val, index);
        if (val.imageUrls != undefined && val.imageUrls.length > 0) {
          return val.imageUrls[index];
        }
        return null;
      }
    },
    isVideoShow() {
      return function (val, index) {
        if (val.videoUrls != undefined && val.videoUrls.length > index) {
          return true;
        }
        return false;
      }
    },
    getVideoUrl() {
      return function (val, index) {
        if (val.videoUrls != undefined && val.videoUrls.length > 0) {
          return val.videoUrls[index];
        }
        return null;
      }
    },
    /*changeTaskNum(){
      return function (taskOrOrderNum) {
        return getStrEndWithNumbers(taskOrOrderNum, 8);
      }
    }

     */
    getFlag(){
      return function (num) {
        switch (num) {
          case 1:
            return require('../../assets/img/1.png')
          case 2:
            return require('../../assets/img/2.png')
          case 3:
            return require('../../assets/img/3.png')
          case 4:
            return require('../../assets/img/4.png')
          case 5:
            return require('../../assets/img/5.png')
          default:
            return require('../../assets/img/0.png')
        }
      }
    }
  },
  mounted() {
    this.myheader.JWTHeaderName = getJwtToken();
    this.getData();
  },
  methods: {
    submitAddReview(){
      this.fullscreenLoading = true
      let taskClass = '20210002';
      if (this.dialogExtraForm.taskChecked == 2) {
        taskClass = '20210003';
      } else if (this.dialogExtraForm.taskChecked == 3) {
        taskClass = '20210004';
      }
      //新增一个字段订单ID
      //this.dialogExtraForm.orderId = this.$route.query.orderId;
      //this.dialogExtraForm.taskDetailId = this.baseTableData.taskDetailId;
      this.dialogExtraForm.taskClass = taskClass;
      this.dialogExtraForm.serviceMoney = this.serviceMoney
      this.dialogExtraForm.commissionMoney = this.commissionMoney
      //this.reviewDataForm.imageUrls.push.apply(this.reviewDataForm.videoUrls);
      addTaskExtraDetailContent(this.dialogExtraForm).then(res => {
        if (res.success) {
          this.getData();
          this.fullscreenLoading = false
          location.reload()
        }
      }).catch(err => {
        this.fullscreenLoading = false
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleMediaRemove(file) {
      //console.log(file)
      let indx = this.dialogExtraForm.imageUrls.findIndex((item)=>item==file);
      this.dialogExtraForm.imageUrls.splice(indx, 1)
      //console.log(this.reviewDataForm.imageUrls, indx)
    },
    handleReviewSuccess(obj, res, file) {
      console.log(obj, res.data, file)
      if (this.dialogExtraForm.imageUrls.length < obj.imgIndex) {
        this.dialogExtraForm.imageUrls.push(res.data);
      } else {
        this.dialogExtraForm.imageUrls.splice(obj.imgIndex, 1, res.data);
      }
    },
    handleExtraCloseDialog(){
      this.$refs[this.dialogExtraRefName].resetFields();
      this.dialogExtraFormVisible = false;
    },
    handleReviewVideoSuccess(obj, res, file) {
      console.log(obj, res.data, file)
      this.fullscreenLoading = false
      if (this.dialogExtraForm.videoUrls.length < obj.videoIndex) {
        this.dialogExtraForm.videoUrls.push(res.data);
      } else {
        this.dialogExtraForm.videoUrls.splice(obj.videoIndex, 1, res.data);
      }
      console.log(this.dialogExtraForm.videoUrls)
    },
    beforeUpload(){
      this.fullscreenLoading = true;
    },
    taskClassChange() {
      let taskClass = '20210002';
      if (this.dialogExtraForm.taskChecked == 2) {
        taskClass = '20210003';
      } else if (this.dialogExtraForm.taskChecked == 3) {
        taskClass = '20210004';
      }
      this.dialogExtraForm.taskClass = taskClass
      getAllReviewServiceMoney(taskClass).then(res => {
        if (res.success) {
          this.serviceMoney = res.data[0].serviceMoney
          this.commissionMoney = res.data[0].comissionMoney
        }
      });
    },
    handleExtraReview(index, row, title){
      let taskClass = '20210002';
      getAllReviewServiceMoney(taskClass).then(res => {
        if (res.success) {
          this.serviceMoney = res.data[0].serviceMoney
          this.commissionMoney = res.data[0].comissionMoney
        }
      });
      this.dialogExtraTitle = title
      this.dialogExtraFormVisible = true
      this.dialogExtraForm = {...this.dialogExtraForm,  ...row}
    },
    handleAddReview(indx, row, title){
      this.$router.push({path: '/home/taskorderdetail', query: {taskNumbers: row.orderNum, orderId: row.orderId}})
    },
    handleBatchPrompReview(){
      addBatchPrompReview(this.multipleSelection).then(res => {
        if (res.success){
          this.$message.success("批量催评成功！")
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePrompReviews(index, row, title){
      addPrompReview({orderId: row.orderId}).then(res => {
        if (res.success){
          this.$message.success("催评成功！")
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitUpdateMoneyDialogForm(){
      this.dialogUpMoneyFormVisible = false;
      if (this.dialogUpMoneyForm.updateMoney == null || parseFloat(this.dialogUpMoneyForm.updateMoney) <= 0){
        this.$message.error("请填写调整金额！");
      }else{
        this.$confirm("确认修改金额?").then(_ => {
          this.dialogUpMoneyForm.statusStr = "确认发货返款";
          updateOrderMoney(this.dialogUpMoneyForm).then(res => {
            if (res.success){
              this.getData();
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        })
      }
    },
    handleUpdateMoneyCloseDialog() {
      this.$refs[this.dialogUpMoneyRefName].resetFields();
      this.dialogUpMoneyFormVisible = false;
    },
    submitOrderReviewDialogForm() {
      if (this.multipleSelection.length > 0) {
        if (this.dialogMoneyForm.reviewMoneyRes) {
          updateBatchOrderStatus({orderIds: this.multipleSelection, stepNum: 4, orderStatus: "待评价"}).then(res => {
            if (res.success) {
              this.dialogMoneyFormVisible = false;
              this.getData();
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        } else {
          updateBatchOrderStatus({
            orderIds: this.multipleSelection,
            stepNum: 2,
            orderStatus: "待操作",
            remarks: this.dialogMoneyForm.remarks
          }).then(res => {
            if (res.success) {
              this.dialogMoneyFormVisible = false;
              this.getData();
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }
      } else {
        if (!isStrEmpty(this.dialogMoneyForm.orderId)) {
          if (this.dialogMoneyForm.reviewMoneyRes) {
            updateOrderStatus({orderId: this.dialogMoneyForm.orderId, stepNum: 4, orderStatus: "待评价"}).then(res => {
              if (res.success) {
                this.dialogMoneyFormVisible = false;
                this.getData();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            });
          } else {
            updateOrderStatus({
              orderId: this.dialogMoneyForm.orderId,
              stepNum: 2,
              orderStatus: "待操作",
              remarks: this.dialogMoneyForm.remarks
            }).then(res => {
              if (res.success) {
                this.handleOrderReviewCloseDialog();
                this.getData();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            });
          }
        }
      }
    },
    handleOrderReviewCloseDialog() {
      this.$refs[this.dialogMoneyRefName].resetFields();
      this.dialogMoneyFormVisible = false;
    },
    handleBatchMoneyOper(title) {
      this.dialogMoneyFormVisible = true;
      this.dialogMoneyTitle = title;
    },
    handleMoneyOper(index, row, title) {
      this.dialogMoneyFormVisible = true;
      this.dialogMoneyForm.orderId = row.orderId;
      this.dialogMoneyForm.reviewRes = row.reviewRes;
      this.dialogMoneyTitle = title;
    },
    handleUpMoneyOper(index, row, title) {
      this.dialogUpMoneyFormVisible = true;
      this.dialogUpMoneyForm.orderId = row.orderId;
      this.dialogUpMoneyTitle = title;
    },
    handleBatchReviewOper() {
      this.dialogReviewFormVisible = true;
      this.dialogReviewTitle = "批量审核";
    },
    handleReviewOper(index, row, title) {
      this.dialogReviewFormVisible = true;
      this.dialogReviewForm.orderId = row.orderId;
      this.dialogReviewForm.userId = row.userId;
      this.dialogReviewTitle = title;
    },
    submitReviewDialogForm() {
      this.$confirm("确认审核?").then(_ => {
        if (this.multipleSelection.length > 0) {
         updateBatchOrderStatus({
            orderIds: this.multipleSelection,
            orderStatus: this.dialogReviewForm.reviewRes,
            remarks: ""
          }).then(res => {
            if (res.success) {
              this.dialogReviewFormVisible = false;
              this.getData();
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        } else {
          if (!isStrEmpty(this.dialogReviewForm.orderId)){
           updateOrderStatus({
              orderId: this.dialogReviewForm.orderId,
              orderStatus: this.dialogReviewForm.reviewRes,
              remarks: ""
            }).then(res => {
              if (res.success) {
                this.dialogReviewFormVisible = false;
                this.getData();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            });
          }
        }
      })
    },
    handleReviewCloseDialog() {
      this.$refs[this.dialogReviewRefName].resetFields();
      this.dialogReviewFormVisible = false;
    },
    handleAppeal(index, row, title) {
      this.dialogAppealFormVisible = true;
      this.dialogAppealForm.orderNumbers = row.orderNum;
      this.dialogAppealTitle = title;
    },
    submitDialogAppealForm() {
      this.$confirm("确认发起申诉?").then(_ => {
        this.dialogAppealForm.appealImageUrl = this.dialogAppealForm.appealImageUrls.join(",");
        commitAppealMessageInfo(this.dialogAppealForm).then(res => {
          if (res.success) {
            this.dialogAppealFormVisible = false;
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      })
    },
    handleCloseDialogAppeal() {
      this.$refs[this.dialogAppealRefName].resetFields();
      this.dialogAppealFormVisible = false;
    },
    handleAvatarSuccess(res, file) {
      this.dialogAppealForm.appealImageUrls.push(res.data);
      let self = this;
      self.$forceUpdate();
    },
    handleAvatarRemove(file) {
      console.log(file);
    },
    cancelOrder() {
      //cancelOrder()
    },
    handleBatchCancelOrder() {
      this.$confirm("确定取消订单?").then(_ => {
        cancelOrders(this.multipleSelection).then(res => {
          if (res.success) {
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      })
    },
    handleFinshconfirmSend() {
      updateBatchOrderStatus({orderIds: this.multipleSelection, stepNum: 6, orderStatus: "已完成"}).then(res => {
        if (res.success) {
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    exportUserOrderInfo(queryForm) {
      window.open("https://api.weiquanai.com/b2corder/exportorderlist?" + qs.stringify({
        shopname: queryForm.shopInfo,
        taskType: queryForm.tasktype,
        taskId: queryForm.taskId,
        orderNum: queryForm.orderNum,
        plateordernum: queryForm.plateordernum,
        customerId: queryForm.customerId,
        plateformUsername: queryForm.plateformUsername,
        reviewstatus: queryForm.reviewstatus,
        status: queryForm.status,
        startTime: queryForm.timeRange ? queryForm.timeRange[0] : null,
        endTime: queryForm.timeRange ? queryForm.timeRange[1] : null,
        businessName: getTokenUser(),
        businessRoleCode: queryForm.roleCode,
        pageNum: -1,
        pageSize: -1
      }), "_blank");
    },
    handleRejectCustomerOrder(index, row, title) {
      this.dialogFormVisible = true;
      this.dialogForm = {...row};
      this.dialogTitle = title
    },
    addData() {
      // this.$confirm("确定驳回订单?")
      //     .then(_ => {
      //       updateOrderStatus({
      //         orderId: this.dialogForm.orderId,
      //         stepNum: 2,
      //         orderStatus: "待操作",
      //         remarks: this.dialogForm.remarks
      //       }).then(res => {
      //         if (res.success) {
      //           this.handleCloseDialog();
      //           this.getData();
      //         }
      //       }).catch(err => {
      //         this.$message({message: err.message, type: 'error'});
      //       });
      //     });
    },
    handleconfirmSend() {
      updateBatchOrderStatus({orderIds: this.multipleSelection, stepNum: 4, orderStatus: "待评价"}).then(res => {
        if (res.success) {
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    confirmSendShip(index, row, title) {
      this.$confirm("确定提交发货返款吗?").then(_ =>{
        updateOrderStatus({orderId: row.orderId, stepNum: 4, orderStatus: "待评价"}).then(res => {
          if (res.success) {
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      });
    },
    goToTask(taskNum) {
      console.log(taskNum)
      this.$router.push({path: '/home/businesstaskdetails', query: {b2cTaskId: taskNum}});
    },
    goToOrder(orderNum) {
      console.log(orderNum)
      this.$router.push({path: '/home/taskorderdetail', query: {taskNumbers: orderNum}});
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      //console.log(this.pagination)
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
    isShow(menu) {
      if (menu == this.currentMenu.value) {
        return true;
      } else {
        return false;
      }
    },
    getData() {
      this.queryForm.status = this.currentMenu.lable;
      getOrderTaskList(this.queryForm, this.pagination).then(res => {
        console.log(this.pagination)
        if (res.success) {
          console.log(res.data)
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
          this.$emit("changePageination", this.pagination);
          this.$forceUpdate();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    changeTabs(tab) {
      this.queryForm.status = tab.lable;
      getOrderTaskList(this.queryForm, this.pagination).then(res => {
        console.log(this.pagination)
        if (res.success) {
          console.log(res.data)
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
          this.$emit("changePageination", this.pagination);
          this.$forceUpdate();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    isOption(menu) {
      console.log(menu, this.currentMenu)
      if (menu.indexOf(this.currentMenu.value) != -1) {
        return true
      } else {
        return false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}

.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 220px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 220px;
  line-height: 220px;
  text-align: center;
}

.avatar {
  width: 220px;
  height: 220px;
  display: block;
}

.extraClass{
  position: relative;

  .demo-image__preview{
    width: 320px;
    height: 320px;
    margin: 2%;
    position: relative;
    border: black solid 1px;
  }

  td span {
    display: inline-block;
  }

  .el-divider {
    border-top: 1px solid red;
    margin: 0;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  .boxself {
    border: 1px solid red;
    margin-left: 28%;
    font-size: smaller;
    height: 100%;

    /deep/ .el-upload--picture-card {
      width: 100px;
      height: 100px;
    }

    /deep/ .el-upload {
      width: 100px;
      height: 100px;
      line-height: 100px;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item {
      width: 100px;
      height: 100px;
      line-height: 100px;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
      width: 100px;
      height: 100px;
      line-height: 100px;
    }

    /deep/ .avatar {
      width: 100px;
      height: 100px;
    }

    .el-input /deep/ .el-input__inner {
      height: 28px;
    }

    .el-form-item {
      margin-bottom: 0px;
    }

    .el-form-item /deep/ .el-form-item__label {
      font-size: smaller;
    }

  }

  #videoTag {
    /deep/ .el-upload--picture-card {
      width: 220px;
      height: 220px;
    }

    /deep/ .el-upload {
      border: 1px dashed gray;
      border-radius: 5px;
      width: 220px;
      height: 220px;
      line-height: 220px;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item {
      width: 220px;
      height: 220px;
      line-height: 220px;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
      width: 220px;
      height: 220px;
      line-height: 220px;
    }

    /deep/ .avatar {
      width: 220px;
      height: 220px;
    }
  }

  .itemCls {
    /deep/ .el-upload--picture-card {
      width: 120px;
      height: 120px;
    }

    /deep/ .el-upload {
      border: 1px dashed gray;
      border-radius: 5px;
      width: 120px;
      height: 120px;
      line-height: 120px;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item {
      width: 120px;
      height: 120px;
      line-height: 120px;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
      width: 120px;
      height: 120px;
      line-height: 120px;
    }

    /deep/ .avatar {
      width: 120px;
      height: 120px;
    }
  }

  .keywordCls {
    max-height: 30px;
    margin: 5px 2px;
    background-color: lightpink;

    .el-input /deep/ .el-input__inner {
      height: 28px;
    }

    .el-form-item {
      margin-bottom: 0px;
    }

    .el-form-item /deep/ .el-form-item__label {
      font-size: smaller;
    }
  }

  .contentCls {
    border: 1px solid red;
    border-radius: 5px;
    margin: 5px;

    .el-form-item {
      margin-bottom: 0px;
    }

    .el-form-item /deep/ .el-form-item__content {
      margin: 1%;
    }
  }

  .a {
    .el-form-item {
      margin-bottom: 10px;
    }

    .el-form-item /deep/ .el-form-item__label {
      margin: 2px;
    }

    .el-form-item /deep/ .el-form-item__content {
      margin: 2px;
    }
  }

  .planCls {
    border: 1px solid red;
    margin: 5px;

    .el-divider {
      margin: 8px 0;
      background: 0 0;
      border-top: 1px solid red;
    }

    .el-form-item {
      margin-bottom: 10px;
    }
  }

  #reviewstyle {
    .el-divider {
      margin: 4px 0;
      background: 0 0;
      border-top: 1px solid gray;
    }
  }

  .avatar-uploader {
    border: 1px dashed gray;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 220px;
  }

  .el-upload {
    border: 1px dashed gray;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 220px;
    height: 220px;
    line-height: 220px;
    text-align: center;
  }

  .avatar {
    width: 220px;
    height: 220px;
    display: block;
  }

  .el-tabs-self {
    position: relative;
    width: 100%;
  }

  span {
    text-align: center;
  }

  .tb-edit .el-input {
    display: none
  }

  .tb-edit .current-row .el-input {
    display: block
  }

  .tb-edit .current-row .el-input + span {
    display: none
  }
}
</style>
